import Vue from 'vue'

export default {
  state: {
    items: null
  },
  mutations: {
    setItems(state, items) {
      state.items = items;
    },
    itemsReset(state) {
      state.items = null;
    },
    itemDelete(state, id) {
      if (state.items) {
        const index = state.items.findIndex(item => item.id === id);
        if (index !== -1)
          state.items.splice(index, 1);
      }
    },
    itemAdd(state, item) {
      if (state.items) {
        const name = item.name.toLowerCase();
        const index = state.items.findIndex(item => name < item.name.toLowerCase());
        if (index !== -1)
          state.items.splice(index, 0, item);
        else
          state.items.push(item);
      }
    },
    itemUpdate(state, item) {
      if (state.items) {
        const index = state.items.findIndex(c => c.id === item.id);
        if (index !== -1)
          state.items.splice(index, 1, item);
      }
    }
  },
  actions: {
    async items({state, commit}) {
      if (!state.items) {
        const items = [];
        await Vue.prototype.$lazyListLoad(items, 'items2', 'id,sku,type,name,trackUnits,precision,category{id},active,sold,upc', 100, []);
        commit('setItems', items);
      }

      return state.items;
    },
    /*
    async itemCreate({commit}, input) {
      const results = await Vue.prototype.$apiCall(`mutation StoreItem($input: ItemInput!) {
                                                      itemCreate(input:$input) {id,name,active,type,currency,salesRep{id}}
                                                    }`,
                                                    {input});
      if (!results.error)
        commit(input.id ? 'itemUpdate' : 'itemAdd', results.data.itemCreate);
      return results;
    }
    */
  }
}